import { useAppSelector } from '../reducers';
import { isUngatedForSeatsSelector } from '../selectors/GatingSelectors';
import { isCoreSeatSkuSelector, isPaidSalesServiceSeatSelector, isQuantifiableHubSelector } from '../selectors/ProductsSelectors';
import { normalizePurchaseMotion } from '../utils/purchaseMotionUtils';
export const usePurchaseMotionButtonProductConfigurations = (productConfigurations, purchaseMotion) => {
  const state = useAppSelector(combinedState => combinedState);
  const normalizedPurchaseMotion = normalizePurchaseMotion(purchaseMotion);

  // if the purchase motion is to buy additional seats, we need to filter out
  // the product configurations that are seats related.
  // (e.g. filter out platform or hub products that shouldn't go to checkout again)
  if (normalizedPurchaseMotion === 'BUY_ADDITIONAL_SEATS' && isUngatedForSeatsSelector(state)) {
    return productConfigurations.filter(config => {
      const isCoreSeat = isCoreSeatSkuSelector(state, {
        skuId: config.skuId
      });
      const isQuantifiableHub = isQuantifiableHubSelector(state, {
        skuId: config.skuId
      });
      const isQuantityPackSeat = isPaidSalesServiceSeatSelector(state, {
        skuId: config.skuId
      });
      return isCoreSeat || isQuantifiableHub || isQuantityPackSeat;
    });
  }
  return productConfigurations;
};